import * as z from "../../../../framework";
import VisibleInterval from "../../../../framework/core/visibleInterval";
import { Chart } from "../../ui";
import { Widget } from "./widget";

// tslint:disable-next-line:variable-name
export var W_Chart = function (widgetInstance?) {
    widgetInstance = widgetInstance || {};

    var widget = new Widget(widgetInstance);
    $.extend(this, widget);

    let chartView = (this.options && this.options.chartOption) || {};
    this.theme = (chartView.theme == "Moonlight" || !chartView.theme)
        ? "Flat"
        : chartView.theme;

    this.entityType = chartView.entityType || "";
    this.filter = chartView.filter;
    this.originalFilter = chartView.filter;
    this.filterDate = chartView.filterDate;
    this.filterId = chartView.filterId;
    this.groupBy = chartView.groupBy;
    this.expand = chartView.expand;
    this.select = chartView.select;
    this.xAxis = chartView.xAxis;
    this.yAxis = chartView.yAxis;
    this.searchOptions = chartView.searchOptions;
    this.dateInterval = chartView.dateInterval;
    this.dateIntervals = chartView.dateIntervals;
    this.chartType = chartView.chartType;
    this.toolTipTemplate = chartView.chartType;

    this.divisions = chartView.divisions === undefined
        ? true
        : chartView.divisions;

    this.regions = chartView.region == undefined
        ? true
        : this.regions;

    this.hideSearchOptions = chartView.hideSearchOptions === undefined
        ? false
        : chartView.hideSearchOptions;

    this.autoBind = chartView.autoBind === undefined
        ? true
        : chartView.autoBind;

    this.liveFilter = chartView.liveFilter === undefined
        ? true
        : chartView.liveFilter;

    this.divisionAndRegionOnly = chartView.divisionAndRegionOnly === undefined
        ? false
        : chartView.divisionAndRegionOnly;

    this.init();
};

W_Chart.prototype = {
    init: function () {
        var me = this;

        var options: any = {
            id: `${me.entityType}Chart`,
            theme: me.theme,
            url: "" + me.entityType,
            entityType: me.entityType,
            select: me.xAxis + ", " + me.yAxis + (me.select ? ", " + me.select : ""),
            expand: me.expand || "",
            groupBy: me.groupBy,
            height: me.height || "300px",
            filter: me.filter || "",
            originalFilter: me.filter || "",
            dateIntervals: me.dateIntervals,
            dateInterval: me.dateInterval,
            filterId: me.filterId || "",
            filterDate: me.filterDate || "",
            inlinecount: me.inlinecount || "",
            divisions: me.divisions !== undefined ? me.divisions : true,
            regions: me.regions !== undefined ? me.regions : true,
            top: me.top || "",
            skip: me.skip || "",
            pageSize: me.pageSize || "",
            orderby: me.orderby || "",
            xAxis: me.xAxis,
            yAxis: me.yAxis,
            searchOptions: me.searchOptions,
            template: me.template || "#= category #: \n #= value#",
            zScreen: me
        };

        var columnView = new Chart({
            id: options.id
        });
        columnView.options.zScreen = me;
        columnView.render(me.contents);
        options.zScreen = me;
        options.title = me.title;
        options.screenId = me.screenId;

        z.controls.chart(options);
        $(`#${options.id}`).hide();

        var defaultInterval = 300000;
        var interval = z.util.getOptionValue("WidgetRefreshInterval", 300) * 1000 as number;
        if (isNaN(interval) || interval == 0) {
            interval = defaultInterval;
        }

        var handleRequests = function () {
            // TODO: BUG: 16149 hide portal container so this fails when the session timeout screen comes up
            if ($("#PortalContainer").css("display") != "none" && z.util.isGuid(z.getToken())) {
                switch (me.chartType) {
                    case "pie":
                        z.charts.handleRequestsForPieChart(options);
                        break;
                    case "bar":
                        me.handleRequestsForBarChart(options);
                        break;
                }
            }
        };

        var widgetRefreshTimer = new VisibleInterval(handleRequests, interval);
        widgetRefreshTimer.start();
        handleRequests();
    },
    // Move this to chart.cs post .18
    handleRequestsForBarChart: function (options) {
        var me = this,
            amIDoneYet = $.Deferred(),
            chart = me.chart,
            barChartData: any = [],
            voodooObject = {},
            barChartCategories;

        options.select = options.select;
        if (!options.select) {
            options.select = "Id";
        }
        options.inlinecount = "allpages";
        options.top = 0;

        var dateFilter;
        if (options.filterDate) {
            dateFilter = new Date();
            dateFilter.setDate(dateFilter.getDate() - 30);
            // dateFilter = "'" + dateFilter.toString("ddd, dd-MMM-yyyy, hh:mm:ss")() + "'";
            dateFilter = dateFilter.toIsoDate();
        }

        if (options.groupByFilter) {
        }

        var voodooCount = 0;
        var getGroupedAjaxCall = z.ajax({
            type: "GET",
            url: options.groupBy
        }).done(function (response) {
            var results = response.d.results;
            for (var i = 0; i < results.length; i++) {

                voodooObject[i] = results[i].Id;

                voodooObject[i] = {
                    category: results[i].CodeNumber,
                    id: results[i].Id,
                    value: 0
                };
                barChartCategories.push(results[i].Id);
                voodooCount++;
            }
        });
        $.when(getGroupedAjaxCall).done(function (a1) {

            var ajaxArray = [];
            for (var a = 0; a < voodooCount; a++) {

                (function (aa) {
                    var url;
                    if (options.filterId && options.filter) {

                        var filterDateString = options.filter;
                        filterDateString = filterDateString.replace("@Date", dateFilter);

                        url = `${options.entityType}?$count&$filter= ${options.filterId} eq ${voodooObject[aa].id} AND ${filterDateString}`;
                    } else {
                        url = `${options.entityType}?$count&$filter= ${options.filterId} eq ${voodooObject[aa].id}`;
                    }
                    ajaxArray.push(z.ajax({
                        type: "GET",
                        url: url
                    }).done(function (countResponse) {
                        var count;
                        if (!countResponse.d.__count) {
                            count = 0;
                        } else {
                            count = countResponse.d.__count;
                        }
                        voodooObject[aa].value = count;
                    }));
                })(a);
            }

            $.whenAll
                .apply($, ajaxArray)
                .always(function () {
                    barChartData = voodooObject;
                    amIDoneYet.resolve();
                });
        });

        amIDoneYet.done(function () {
            me.renderBarChart({
                chart: chart,
                yAxis: barChartData,
                barChartData: barChartData
            });

            me.contents.unmask();
        });
    },
    renderBarChart: function (args) {
        var chart = args.chart.kendoChart({
            theme: args.theme,
            legend: {
                visible: false
            },
            chartArea: {
                background: "",
                width: args.chart.width(),
                margin: {
                    top: 50,
                    bottom: 50,
                    left: 100,
                    right: 100
                }
            },

            categoryAxis: {
                categories: args.yAxis.toString()
            },
            seriesDefaults: {
                type: "column",
                labels: {
                    visible: true,
                    background: "transparent",
                    template: args.template
                }
            },
            series: [{
                type: "column",
                field: "value",
                name: "id",

                data: args.barChartData
            }],
            tooltip: {
                visible: true,
                format: "",
                template: args.template
            }
        });

        var widgetTitle = this.title;
        var screenIndx = this.screenId.indexOf("_");
        var screenId = this.screenId.substr(0, screenIndx);

        $(`#${screenId}_WidgetContainer_PrintButton`).off().tie("click", function () {
            chart.getKendoChart().exportImage().done(function (data) {
                kendo.saveAs({
                    dataURI: data,
                    fileName: `${widgetTitle} Export.png`
                });
            });
        });
    }
};
